import {Loading} from '@hm/fundamental'
import {useSuiteHierarchyId, usePlantHierarchyQuery} from '@hproduce/suite-core'
import React from 'react'
import {Outlet} from 'react-router'

import {getHierarchyNodeById} from '../Components/Base/header/PlantSelectButton/getHierarchyNodeNameById'

import {AccessDeniedPage} from './AccessDeniedPage'
import {NoHierarchyPage} from './NoHierarchyPage'

export const HierarchyIdGuard: React.FC = () => {
  const {data: plantHierarchy, isPending} = usePlantHierarchyQuery()
  const hierarchyId = useSuiteHierarchyId()

  if (!isPending && !hierarchyId && plantHierarchy?.length === 0) {
    return <NoHierarchyPage />
  }

  if (isPending || !hierarchyId) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loading size="xlarge" data-cy="hierarchy_loader" />
      </div>
    )
  }

  // The hierarchy only holds nodes the user may access, e.g. a plant linked from another page
  if (plantHierarchy && !getHierarchyNodeById(plantHierarchy, hierarchyId)) {
    return <AccessDeniedPage />
  }

  return <Outlet />
}
